import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import NumberFormat from 'react-number-format'
import { FaWhatsapp } from 'react-icons/fa'

import RectangleExample from '../../assets/rectangle.svg'
import CustomAlert from '../Alert/Alert'
import { addToCart } from '../../redux/products/cartSlice'

import './cardProduct.css'

const TELEFONO_WPP = '5491161670393'

const Envoltorio = ({ conLink, href, className, children }) =>
  conLink ? (
    <a className={className} href={href}>
      {children}
    </a>
  ) : (
    <div className={className}>{children}</div>
  )

// conLink controla si la card enlaza al detalle del producto. En /productos la
// card ya muestra todo (descripción, precio y acción), así que se apaga; el
// carrusel del inicio la sigue usando como acceso al detalle.
const CardProduct = ({ product, conLink = true }) => {
  const dispatch = useDispatch()
  const [alert, setAlert] = useState(undefined)

  // precio_a_consultar llega como 1/0 desde MySQL. Los endpoints que no hacen
  // SELECT * no lo mandan, y en ese caso se muestra el precio como siempre.
  const aConsultar = Number(product.precio_a_consultar) === 1
  const sinStock = Number(product.stock) === 0

  // La API devuelve categoria en null si el id no matchea con ninguna, así que
  // no se puede asumir que siempre venga un string.
  const categoria = product.categoria || ''

  const linkProducto = `/productos/${categoria.toLowerCase()}/${product.id}`

  const linkConsulta = `https://api.whatsapp.com/send?phone=${TELEFONO_WPP}&text=${encodeURIComponent(
    `Hola! Quisiera consultar el precio de: ${product.nombre}`
  )}`

  const addCart = () => {
    dispatch(
      addToCart({
        id: product.id,
        image: product.imagen?.[0],
        nombre: product.nombre,
        categoria: product.categoria,
        precio: parseInt(product.precio),
        stock: product.stock,
        cantidad: 1
      })
    )

    setAlert({ msg: 'Producto agregado al carrito', variant: 'success' })
    setTimeout(() => {
      setAlert(undefined)
    }, 4000)
  }

  return (
    <>
      <CustomAlert alert={alert} />
      <div
        className={`card-product animate__animated animate__fadeIn animate__delay-0${product.id}s`}
      >
        {/* Con link es un <a>, sin link un <div>: mantener el mismo envoltorio
        en los dos casos deja los estilos y el espaciado intactos. */}
        <Envoltorio className='imagen' conLink={conLink} href={linkProducto}>
          <img
            src={
              product?.imagen?.length > 0
                ? `${process.env.REACT_APP_URL_BACKEND_BASE}/${product.imagen[0]}`
                : RectangleExample
            }
            alt=''
          />
        </Envoltorio>

        <div className='card-body'>
          {categoria && (
            <span className='badge badge-categoria'>{categoria}</span>
          )}

          <Envoltorio className='titulo' conLink={conLink} href={linkProducto}>
            <h3>{product.nombre}</h3>
          </Envoltorio>

          {product.descripcion && (
            <p className='description'>{product.descripcion}</p>
          )}

          {aConsultar ? (
            <span className='badge badge-consultar'>Precio a consultar</span>
          ) : (
            <NumberFormat
              className='price'
              value={product.precio}
              displayType='text'
              thousandSeparator='.'
              decimalSeparator=','
              prefix='$'
            />
          )}

          {aConsultar ? (
            <a
              className='btn-card btn-consultar'
              href={linkConsulta}
              target='_blank'
              rel='noreferrer'
            >
              <FaWhatsapp />
              <span>Consultar por WhatsApp</span>
            </a>
          ) : (
            // El listado público no filtra por stock, así que los productos
            // agotados también llegan acá y no se pueden agregar al carrito.
            <button
              type='button'
              className='btn-card btn-agregar'
              onClick={addCart}
              disabled={sinStock}
            >
              {sinStock ? 'Sin stock' : 'Agregar al carrito'}
            </button>
          )}
        </div>
      </div>
    </>
  )
}

export default CardProduct
